import {useEffect, useState} from 'react';
import { charterModelData } from '../../services/ModelService';
import { keyBy, values } from 'lodash';

export default function useAllCharters() {
    const [loading, setLoading] = useState(true);
    const [allData, setAllData] = useState(null);
    const [allEnquiries, setAllEnquiries] = useState(null);
    const [allCharters, setAllCharters] = useState(null);
    const [allChartersArray, setAllChartersArray] = useState(null);
    const [allEnquiriesArray, setAllEnquiriesArray] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const charters = await charterModelData.getAll();
                setAllData(charters);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        };

        load().then(() => console.log('Charter List Updated.'));

        const listener = charterModelData.addListener({
            setterFn: setAllData, loaded: charters => {
                setAllData(charters);
            }
        });

        return () => {
            if (listener)
                charterModelData.removeListener(listener);
        };
    }, [setAllEnquiries, setAllCharters]);

    useEffect(() => {
        const setData = (data) => {
            setLoading(true);
            const dataAsArray = values(data);
            const enquiries = dataAsArray.filter(c => c.type === 'express');
            const charters = dataAsArray.filter(c => c.type !== 'express');

            setAllEnquiries(keyBy(enquiries, 'charterId'));
            setAllCharters(keyBy(charters, 'charterId'));
            setAllEnquiriesArray(enquiries);
            setAllChartersArray(charters);
            setLoading(false);
        }
        if(!allData) return;
        setData(allData);
    }, [allData, setAllData, setAllEnquiries, setAllCharters, setAllEnquiriesArray, setAllChartersArray]);

    return {
        allCharters, allChartersArray, allEnquiries, allEnquiriesArray,
        loading
    };
}